import { render, staticRenderFns } from "./CommunityCardPreview.vue?vue&type=template&id=3a450044&"
import script from "./CommunityCardPreview.vue?vue&type=script&lang=js&"
export * from "./CommunityCardPreview.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCardPreview.vue?vue&type=style&index=0&id=3a450044&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports